import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SaveCancelButton from '../save-cancel-button/SaveCancelButton.jsx';

import s from './ConfirmationModal.module.scss';

Modal.setAppElement('#root');

const ConfirmationModal = ({ title, subtitle, okLabel, cancelLabel, onClose, open }) => (
    <Modal isOpen={open} className={s.modal} overlayClassName={s.overlay}>
        <div className={s.titleWrapper}>
            <div className={s.title}>{title}</div>
            <div className={s.subtitle}>{subtitle}</div>
        </div>
        <div className={s.buttonGroup}>
            <SaveCancelButton saveLabel={okLabel} cancelLabel={cancelLabel} saveEnabled onCancel={() => onClose(false)} onSave={() => onClose(true)} />
        </div>
    </Modal>
);
ConfirmationModal.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    okLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onClose: PropTypes.func,
    open: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
    title: 'Closing the POI window means your changes will not be saved',
    subtitle: 'Are you sure you want to continue?',
    okLabel: 'YES',
    cancelLabel: 'CANCEL',
    onClose: () => {},
    open: false,
};

export default ConfirmationModal;
